/**
 * Scheduler status dot for Billing sidebar footer (UI-SPEC §Pattern 7).
 * Color band — green if last tick <2min ago, yellow if 2–10min, red if >10min.
 * Phase 3 v1: status is read from the api-server's existing /healthz endpoint
 * — no dedicated /billing/health endpoint yet. The dot is purely cosmetic and
 * does NOT block any flow.
 */
interface Props {
  lastTick: Date | null;
}

export function SchedulerStatusDot({ lastTick }: Props) {
  const now = Date.now();
  let color = "bg-red-500";
  let label = "stale";
  if (lastTick) {
    const ageMs = now - lastTick.getTime();
    if (ageMs < 2 * 60_000) { color = "bg-green-500"; label = "active"; }
    else if (ageMs < 10 * 60_000) { color = "bg-yellow-500"; label = "delayed"; }
  }
  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      <span className={`w-2 h-2 rounded-full ${color}`} aria-hidden />
      Scheduler {label}
      {lastTick ? (
        <span className="ml-auto">{new Date(lastTick).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}</span>
      ) : null}
    </div>
  );
}
